/**
 * Base URL of the backend API. Used by the browser to call the API.
 * Set via VITE_API_URL at build time (e.g. in Docker or .env).
 * In production this must be the public URL of the backend (e.g. https://api.example.com).
 */
export const API_BASE =
  (import.meta.env?.VITE_API_URL as string | undefined) ?? "http://localhost:8080";
